'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import RadioOption from './RadioOption';
import TextareaInput from './TextareaInput';
import type { RSVPFormData } from './RSVPPageClient';

const foodOptions = [
  { value: 'veg', label: '🥗 Vegetarian' },
  { value: 'nonveg', label: '🍗 Non-vegetarian' },
  { value: 'jain', label: '🌿 Jain' },
  { value: 'other', label: 'Other' },
];

export default function Section10Misc() {
  const { register } = useFormContext<RSVPFormData>();

  const sectionNumber = 10;

  return (
    <FormSection number={sectionNumber} title="A Few More Things">
      <FormField label="Food preference">
        <div className="grid gap-2 mt-1">
          {foodOptions.map((opt) => (
            <RadioOption
              key={`food-${opt.value}`}
              name="food"
              value={opt.value}
              label={opt.label}
              registerProps={register('food')}
            />
          ))}
        </div>
      </FormField>

      <FormField
        label="Does anyone in your group have food allergies or dietary requirements?"
        helper="Leave blank if not applicable"
      >
        <TextareaInput
          placeholder="e.g. Nut allergy, lactose intolerant, gluten-free"
          registerProps={register('dietaryRequirements')}
        />
      </FormField>

      <FormField label="Is there anything else we should arrange or know about?">
        <TextareaInput
          placeholder="Anything that would help us make your stay comfortable — wheelchair accessibility, special assistance, etc."
          registerProps={register('additionalNotes')}
        />
      </FormField>
    </FormSection>
  );
}